import { createContext, useContext } from "react";
import { TabKey } from "../../redux/features/raffle/renders/christmas-raffle/AllPrizesModal/utils/types";

export const RaffleContext = createContext<{
  viewAllPrizes: (tabKey: TabKey) => void;
  onCloseModal: () => void;
  howToPlayClick: () => void;
  onCompetitionClick: (item: any) => void;
  setPointsByCompetitionType: (item: any) => number;
  activeCompetitions: any[];
  activeCompetitionsLoading: boolean;
  showAllCompetitions: boolean;
  seeAllCompetitionsClick: () => void;
  isEndState: boolean;
  hasSubscription: boolean;
}>({
  viewAllPrizes: (tabKey: TabKey) => { },
  onCloseModal: () => { },
  howToPlayClick: () => { },
  onCompetitionClick: item => { },
  activeCompetitions: [],
  activeCompetitionsLoading: false,
  setPointsByCompetitionType: item => 0,
  showAllCompetitions: false,
  seeAllCompetitionsClick: () => { },
  isEndState: false,
  hasSubscription: false,
});

export const useRaffleContext = () => useContext(RaffleContext);
